export default "__VITE_ASSET__ByDmVOnT__"